import { render, staticRenderFns } from "./UserProtocol.vue?vue&type=template&id=f39c5f68&scoped=true&"
import script from "./UserProtocol.vue?vue&type=script&lang=js&"
export * from "./UserProtocol.vue?vue&type=script&lang=js&"
import style0 from "./UserProtocol.vue?vue&type=style&index=0&id=f39c5f68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39c5f68",
  null
  
)

export default component.exports